export const TimerAction = {
    PAUSE: "PAUSE",
    RESUME: "RESUME",
    HOLD: "HOLD",
    DELETE:"DELETE"
  };
  